import OAuthLogin from './OAuthLogin';

export default OAuthLogin;
